<div class="">
  <div class="card">
    <div class="card-body pt-0 pb-0">
      <app-slipcase-item-content [newsItem]="newsItem"></app-slipcase-item-content>
    </div>
  </div>
</div>
